import { render } from "./ModalRemoveCustomer.vue?vue&type=template&id=12b2f7ae"
import script from "./ModalRemoveCustomer.vue?vue&type=script&lang=js"
export * from "./ModalRemoveCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__